import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import PracticeAreaPage from "../pages/practice-areas/page";
import ContactPage from "../pages/contact/page";
import ResultsPage from "../pages/results/page";
import PhiladelphiaPage from "../pages/locations/philadelphia/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/practice-areas",
    element: <PracticeAreaPage />,
  },
  {
    path: "/practice-areas/:slug",
    element: <PracticeAreaPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/results",
    element: <ResultsPage />,
  },
  {
    path: "/locations/philadelphia",
    element: <PhiladelphiaPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
